import Usuario from 'Interface/Usuarios';
import { useAppSelector } from 'Store';

export const useToken = (): string => {
  const token = useAppSelector((state) => state.autenticacao.token);

  return token || '';
};

export const useIdentity = (): Usuario | false => {
  const user = useAppSelector((state) => state.autenticacao.usuario);

  if (user) {
    return user;
  }

  return false;
};

export const useRedirectUrl = (): string | false => {
  const permission = useAppSelector(
    (state) => state.autenticacao.usuario?.permissao
  );

  switch (permission) {
    case 'super':
    case 'admin':
      return '/admin/usuarios';
    case 'conteudista':
      return '/admin/inicio';
  }

  return false;
};
